module.exports = __webpack_public_path__ + "img/3 - Justin Wotrhe.94c7f523.jpg";